import React, { useEffect, useRef } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  isVisible: boolean;
}

export const ListItemHighlight: React.FC<Props> = ({ isVisible }) => {
  const theme = useTheme();

  const opacityValue = useRef(new Animated.Value(isVisible ? 1 : 0));

  useEffect(() => {
    Animated.timing(opacityValue.current, {
      duration: isVisible ? 1 : 250,
      toValue: isVisible ? 1 : 0,
      useNativeDriver: true,
    }).start();
  }, [isVisible]);

  return (
    <Animated.View
      style={{
        ...StyleSheet.absoluteFillObject,
        backgroundColor: theme.sk.color.bg.highlight.tertiary,
        opacity: opacityValue.current,
      }}
    />
  );
};
